import React from 'react';
import {
  IconFileText,
  IconCircleCheck,
  IconCircleX,
  IconAlertTriangle,
  IconShield,
  IconHelpCircle,
  IconCreditCard
} from '@tabler/icons-react';

const sections = [
  {
    icon: <IconFileText className="w-5 h-5" />,
    title: 'Общие положения',
    content: (
      <p>
        Используя сервис XN Connect (далее — «Сервис»), вы соглашаетесь с настоящими Условиями использования.
        Если вы не согласны с каким-либо пунктом, пожалуйста, прекратите использование Сервиса.
      </p>
    )
  },
  {
    icon: <IconCircleCheck className="w-5 h-5" />,
    title: 'Описание сервиса',
    content: (
      <ul className="space-y-2">
        <li>XN Connect предоставляет TCP-туннели (проброс портов) для игр и приложений.</li>
        <li>Сервис позволяет публиковать локальные серверы в интернет через выделенные узлы.</li>
        <li>Сервис предоставляется «как есть» (as is) без каких-либо гарантий.</li>
      </ul>
    )
  },
  {
    icon: <IconCircleX className="w-5 h-5" />,
    title: 'Запрещённые действия',
    content: (
      <ul className="space-y-2">
        <li>Использование туннелей для DDoS-атак или иных противоправных действий.</li>
        <li>Распространение вредоносного ПО через туннели.</li>
        <li>Попытки несанкционированного доступа к чужим аккаунтам или узлам.</li>
        <li>Использование сервиса для обхода блокировок сайтов, запрещённых на территории РФ.</li>
        <li>Создание чрезмерной нагрузки на узлы (fair use policy — не более 5 ТБ трафика в месяц на бесплатном тарифе).</li>
      </ul>
    )
  },
  {
    icon: <IconShield className="w-5 h-5" />,
    title: 'Аккаунт и оплата',
    content: (
      <ul className="space-y-2">
        <li>Вы несёте ответственность за сохранность своих учётных данных.</li>
        <li>Платные подписки оплачиваются через сторонний платёжный процессор. Возвраты обрабатываются согласно его правилам.</li>
        <li>Мы оставляем за собой право заблокировать аккаунт при нарушении условий без возврата средств.</li>
      </ul>
    )
  },
  {
    icon: <IconAlertTriangle className="w-5 h-5" />,
    title: 'Отказ от ответственности',
    content: (
      <ul className="space-y-2">
        <li>Сервис может быть временно недоступен по техническим причинам (обслуживание узлов, аварии).</li>
        <li>Мы не несём ответственности за утечку данных или взлом вашего сервера через открытый туннель.</li>
        <li>Ответственность за содержимое трафика несёт исключительно пользователь.</li>
      </ul>
    )
  },
  {
    icon: <IconCreditCard className="w-5 h-5" />,
    title: 'Fair Use Policy',
    content: (
      <p>
        Бесплатные аккаунты ограничены 5 ТБ трафика в месяц. Превышение лимита может привести
        к временной блокировке туннелей до конца месяца. Платные тарифы имеют индивидуальные лимиты,
        указанные на странице подписки.
      </p>
    )
  },
  {
    icon: <IconHelpCircle className="w-5 h-5" />,
    title: 'Контакты',
    content: (
      <p>
        По всем вопросам обращайтесь в Telegram: <a href="https://t.me/XNCsup_bot" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:underline">@XNCsup_bot</a>.
      </p>
    )
  }
];

const TermsPage = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-white dark:bg-dark-950 transition-colors">
      <div className="max-w-[800px] mx-auto px-6 py-20 sm:py-28">
        <div className="mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-500/10 border border-primary-500/20 rounded-full mb-4">
            <IconFileText className="w-4 h-4 text-primary-500" />
            <span className="text-primary-500 text-[13px] font-semibold">Условия использования</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Условия использования
          </h1>
          <p className="text-gray-600 dark:text-dark-400 text-sm">
            Последнее обновление: {currentYear}
          </p>
        </div>

        <div className="space-y-10">
          {sections.map((section) => (
            <div key={section.title} className="bg-gray-50 dark:bg-dark-900/50 rounded-xl p-6 sm:p-8 border border-gray-200 dark:border-dark-800">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary-500/10 rounded-lg flex items-center justify-center text-primary-500">
                  {section.icon}
                </div>
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{section.title}</h2>
              </div>
              <div className="text-gray-600 dark:text-dark-400 text-sm leading-relaxed space-y-2">
                {section.content}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
